import {
  GET_COUNTRY_INFO
} from './mutation-types.js'

// import {setStore, getStore} from '../config/mUtils'
// import {localapi, proapi} from 'src/config/env'

export default {
  [GET_COUNTRY_INFO](state, country) {
    state.country = country;
    state.country = Object.assign({}, state.country);
  },
}
